import React from 'react'

const Skills = () => (
    <section className="row skills">
        <div className="col-sm-12 col-md-4">
            <p className="title-skills">
                <i className="far fa-star" />Vešči razvijalci
            </p>
            <p className="text-skills">
                Svojim strankam želimo ponuditi zgolj prvovrstne spletne razvijalce.
            </p>
        </div>
        <div className="col-sm-12 col-md-4">
            <p className="title-skills">
                <i className="fas fa-phone" />Pokličite nas
            </p>
            <p className="text-skills">
                Strankam omogočamo komunikacijo neposredno z razvijalcem na vašem projektu.
            </p>
        </div>
        <div className="col-sm-12 col-md-4">
            <p className="title-skills">
                <i className="far fa-heart" />Prepričani?
            </p>
            <p className="text-skills">
                Pri vsakem projektu ohranjamo trezno glavo. In kar je najbolj pomembno: ob tem, kar
                delamo, uživamo!
            </p>
        </div>
    </section>
)

export default Skills



// WEBPACK FOOTER //
// ./src/components/Skills.js